import * as datafile from "./LocationData.js";

const cWhite = "white", cBlue = "blue", cIndigo = "indigo", cBlack = "black", cCyan = "teal", cOrange = "orange", cRed = "red", cDeepOrange = "deep-orange";
var favLocations = new Set(); 

export function addFavLocation(location) {
    return favLocations.add(location);
}

export function hasFavLocation(location) {
    return favLocations.has(location);
}

export function delFavLocation(location) {
    return favLocations.delete(location);
}

export function getColorFromValue(param, value) {
    const val = Math.round(value);
    var color = "";

    if (param.search(datafile.param_Rm) == 0) {    // rainy mm fields 
        switch (true) {
            case (val < 25):
                color = cWhite;
                break;
            case (val < 50):
                color = cBlue + " lighten-5"
                break;
            case (val < 75):
                color = cBlue + " lighten-4"
                break;
            case (val < 100):
                color = cBlue + " lighten-3"
                break;
            case (val < 125):
                color = cBlue + " lighten-2"
                break;
            case (val < 150):
                color = cBlue + " lighten-1"
                break;
            case (val < 175):
                color = cBlue
                break;
            case (val < 200):
                color = cBlue + " darken-1"
                break;
            case (val < 225):
                color = cBlue + " darken-2"
                break;
            case (val < 250):
                color = cBlue + " darken-3"
                break;
            case (val < 275):
                color = cBlue + " darken-4"
                break;
            case (val < 300):
                color = cIndigo + " darken-1"
                break;
            case (val < 350):
                color = cIndigo + " darken-2"
                break;
            case (val < 400):
                color = cIndigo + " darken-3"
                break;
            case (val < 500):
                color = cIndigo + " darken-4"
                break;
            default:
                color = cBlack
        }
    } else if (param.search(datafile.param_Rd) == 0) {  // rainy days fields
        switch (true) {
            case (val < 2):
                color = cWhite;
                break;
            case (val < 5):
                color = cBlue + " lighten-5"
                break;
            case (val < 7):
                color = cBlue + " lighten-4"
                break;
            case (val < 10):
                color = cBlue + " lighten-3"
                break;
            case (val < 13):
                color = cBlue + " lighten-2"
                break;
            case (val < 15):
                color = cBlue + " lighten-1"
                break;
            case (val < 17):
                color = cBlue
                break;
            case (val < 20):
                color = cBlue + " darken-2"
                break;
            case (val < 23):
                color = cBlue + " darken-4"
                break;
            case (val < 26):
                color = cIndigo + " darken-1"
                break;
            default:
                color = cBlack
        }
    } else if (param.search("C") > 0) {   // all temperature related fields
        switch (true) {
            case (val < -4):
                color = cCyan + " darken-1";
                break;
            case (val < -2):
                color = cCyan + " lighten-1";
                break;
            case (val < 0):
                color = cCyan + " lighten-3";
                break;
            case (val < 5):
                color = cCyan + " lighten-5";
                break;
            case (val < 10):
                color = cWhite
                break;
            case (val < 12):
                color = cOrange + " lighten-5";
                break;
            case (val < 14):
                color = cOrange + " lighten-4";
                break;
            case (val < 16):
                color = cOrange + " lighten-3";
                break;
            case (val < 18):
                color = cOrange + " lighten-2";
                break;
            case (val < 20):
                color = cOrange + " lighten-1";
                break;
            case (val < 22):
                color = cOrange;
                break;
            case (val < 24):
                color = cOrange + " darken-1";
                break;
            case (val < 26):
                color = cOrange + " darken-2";
                break;
            case (val < 28):
                color = cOrange + " darken-3";
                break;
            case (val < 30):
                color = cOrange + " darken-4";
                break;
            case (val < 32):
                color = cDeepOrange + " darken-2" //cRed;
                break;
            case (val < 34):
                color = cDeepOrange + " darken-3";
                break;
            case (val < 36):
                color = cRed + " darken-2";
                break;
            case (val < 38):
                color = cRed + " darken-3";
                break;
            default:
                color = cRed + " darken-4";
        }
    }

    if ((color.search("darken") > 0) || (color.search(cBlack) == 0)) {
        color = "white--text " + color;
    }
    return color;
}